import React from 'react'

const Spinner = function(props) {
  return(
    <div className={`spinner-icon ${props.spinnerColour}`}/>
  )
}

export default Spinner
